import { useLocalStorage } from "react-use"
import { ZodTypeDef, z } from "zod"

type Args<T> = {
  key: string
  schema: z.ZodSchema<T, ZodTypeDef, unknown>
  initialValue?: T
}

export function useSafeLocalStorage<T>(args: Args<T>) {
  const handles = useLocalStorage(args.key, args.initialValue, {
    raw: false,
    serializer: JSON.stringify,
    deserializer: (value) => {
      try {
        const raw = JSON.parse(value)
        return args.schema.parse(raw)
      } catch {
        removeKeyHandle()
        return args.initialValue as T
      }
    },
  })

  function removeKeyHandle() {
    localStorage.removeItem(args.key)
  }

  return handles
}
